import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Children, useMemo } from "react";
export const Reorderer = ({ children, order }) => {
    const arrayChildren = Children.toArray(children);
    const reOrderedChildren = useMemo(() => {
        const newChildren = order.map((index) => arrayChildren[index]);
        arrayChildren.forEach((child) => {
            if (!newChildren.includes(child))
                newChildren.push(child);
        });
        return newChildren;
    }, [arrayChildren, order]);
    return _jsx(_Fragment, { children: Children.toArray(reOrderedChildren) });
};
